'use strict';

import animationsUtility from '../utility/animations.js';

const init = () => {
    document.querySelectorAll('.tc-website-scrollingkeywords').forEach(scrollingKeywords => {
        animationsUtility.animateScrollingKeywords(scrollingKeywords)
    })
}

export default {init}
